import { CommonModule } from '@angular/common'
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core'
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser'
import { TabNamesEnums } from '@rush-shared/enums'
import { TabModel } from '@rush-shared/models'
import { RushGameService, RushMainService } from '@rush-shared/services'
import { environment } from '@src/environments/environment'

@Component({
  selector: 'app-live-video',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './live-video.component.html',
  styleUrl: './live-video.component.sass',
})
export class LiveVideoComponent implements OnInit {
  @ViewChild('videoContainer') videoContainer: ElementRef

  get clientHeight(): number {
    return this.videoContainer?.nativeElement.clientHeight || 0
  }
  get clientWidth(): number {
    return this.videoContainer?.nativeElement.clientWidth || 0
  }

  tabNamesEnums = TabNamesEnums
  activeTab: TabModel
  loaded = false

  streamName = environment.nanoStream.rushStreamName

  constructor(
    public _rushGameService: RushGameService,
    private _rushMainService: RushMainService,
    public _sanitizer: DomSanitizer,
  ) {}

  ngOnInit(): void {
    this._rushMainService.activeTab$.observer.subscribe((activeTab) => {
      this.activeTab = activeTab
      this.loaded = this.loaded || activeTab.name === TabNamesEnums.RUSH
    })
  }
}
